import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import Dropdown from 'react-bootstrap/Dropdown';
import chevronDown from '../../../../assets/images/icons/chevronDown.svg';
import './ActionDropdown.scss';
import { putRequest, deleteRequest } from '../../../requestUtils';
var ActionDropdown = /*#__PURE__*/function (_Component) {
  function ActionDropdown(props) {
    var _this;
    _classCallCheck(this, ActionDropdown);
    _this = _callSuper(this, ActionDropdown, [props]);
    _this.state = {};
    _this.handlePutRequest = _this.handlePutRequest.bind(_this);
    return _this;
  }
  _inherits(ActionDropdown, _Component);
  return _createClass(ActionDropdown, [{
    key: "handlePutRequest",
    value: function handlePutRequest(link, updateStateHandler) {
      var csrfToken = this.props.csrfToken;
      if (link) {
        putRequest(link, {}, csrfToken).then(function (response) {
          updateStateHandler(response.data);
        })["catch"](function (err) {
          if (err) {
            alert(err);
          }
        });
      }
    }
  }, {
    key: "handleDeleteRequest",
    value: function handleDeleteRequest(link, redirectHandler) {
      var csrfToken = this.props.csrfToken;
      if (link && confirm('Are you sure you want to delete this?')) {
        deleteRequest(link, csrfToken).then(function (response) {
          redirectHandler(response.data);
        })["catch"](function (err) {
          if (err) {
            alert(err);
          }
        });
      }
    }
  }, {
    key: "renderItem",
    value: function renderItem(link, index) {
      var _this2 = this;
      var id = this.props.id;
      switch (link[0]) {
        case 'separator':
          return /*#__PURE__*/React.createElement("hr", {
            key: link[4] || "separator-".concat(index)
          });
        case 'put':
          return /*#__PURE__*/React.createElement("button", {
            type: "button",
            key: "put-".concat(index),
            className: "dropdown-item",
            onClick: function onClick() {
              return _this2.handlePutRequest(link[2], link[3]);
            }
          }, link[1]);
        case 'delete':
          return /*#__PURE__*/React.createElement("div", {
            className: "delete-container",
            key: "delete-".concat(index)
          }, /*#__PURE__*/React.createElement("button", {
            type: "button",
            className: "delete-link",
            onClick: function onClick() {
              return _this2.handleDeleteRequest(link[2], link[3]);
            }
          }, link[1]), /*#__PURE__*/React.createElement("i", {
            className: "fa fa-trash-alt"
          }));
        case 'link':
          return /*#__PURE__*/React.createElement("a", {
            key: "".concat(id, "-link-").concat(index),
            className: "dropdown-item ".concat(link[4]),
            href: link[2],
            target: link[3]
          }, link[0] === 'link' ? link[1] : link[0]);
        default:
          return /*#__PURE__*/React.createElement("div", {
            className: "dropdown-item",
            key: "item-".concat(index)
          }, link[1]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        id = _this$props.id,
        links = _this$props.links,
        defaultLabel = _this$props.defaultLabel,
        isDisabled = _this$props.isDisabled,
        plainTrigger = _this$props.plainTrigger,
        menuStyle = _this$props.menuStyle,
        toggleStyle = _this$props.toggleStyle,
        indicatorIcon = _this$props.indicatorIcon,
        buttonVariant = _this$props.buttonVariant;
      return /*#__PURE__*/React.createElement(Dropdown, {
        size: "md",
        className: "bulk-actions-dropdown",
        disabled: isDisabled,
        id: id
      }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
        variant: buttonVariant,
        tag: plainTrigger ? 'span' : 'button',
        className: "nav-link dropdown-toggle bulk-action-label ".concat(toggleStyle, " ").concat(isDisabled && 'disabled')
      }, defaultLabel, !plainTrigger && /*#__PURE__*/React.createElement(SVG, {
        src: indicatorIcon || chevronDown,
        className: "chevron"
      })), /*#__PURE__*/React.createElement(Dropdown.Menu, {
        className: menuStyle
      }, links.map(function (link, index) {
        return _this3.renderItem(link, index);
      })));
    }
  }]);
}(Component);
ActionDropdown.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultLabel: PropTypes.node,
  links: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf(['link', 'function', 'info', 'hidden', 'separator']), PropTypes.oneOfType([PropTypes.string, PropTypes.node]), PropTypes.oneOfType([PropTypes.string, PropTypes.func]), PropTypes.object]))).isRequired,
  isDisabled: PropTypes.bool,
  plainTrigger: PropTypes.bool,
  toggleStyle: PropTypes.string,
  menuStyle: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  indicatorIcon: PropTypes.node,
  buttonVariant: PropTypes.string
};
ActionDropdown.defaultProps = {
  id: 'bulk',
  defaultLabel: 'Actions',
  isDisabled: false,
  plainTrigger: false,
  toggleStyle: '',
  menuStyle: 'bulk-actions-menu',
  indicatorIcon: null,
  buttonVariant: 'primary'
};
export default ActionDropdown;